import { isSelTouchingLastBlock } from '../utils';


export const TrimSelection = (opts = {}) => ({
  onKeyDown(e, change, editor) {
    const { value } = change;
    const { isForward, blocks, selection } = value;

    // Current selection looks like on the end edge of last block
    // but actually on the start of the next block that shouldn't
    // be selected. Operating in this slate tends to do some weird
    // shit, so trim the selection.
    const shouldBeTrimmed = isSelTouchingLastBlock(value);

    if (shouldBeTrimmed) {
      const node = blocks.pop().last();
      const trimmed = (isForward
        ? selection.moveFocusToEndOf(node)
        : selection.moveAnchorToEndOf(node)
      );

      change.select(trimmed);
    }

    // return undefined, so to let any downstream
    // operations to take place.
    return;
  }
});



// WEBPACK FOOTER //
// ./src/components/slate/plugins/TrimSelection.js